import { create, destroy } from '@dojo/framework/core/vdom';
import { documentTitleUpdate, lccstate } from '..';
const factory = create({ destroy, lccstate });
export const documentapi = factory(({ middleware: { destroy, lccstate } }) => {
    const { get, path } = lccstate;
    const handles = [];
    destroy(() => {
        let handle;
        while ((handle = handles.pop())) {
            handle();
        }
    });
    const api = {
        tracked: {
            title: get(path('title'))
        },
        setup() {
            this.setDocument();
            const store = lccstate.getStore();
            const { path } = store;
            const handle = store.onChange([path('title')], () => {
                this.setDocument();
            });
            handles.push(() => handle.remove());
        },
        setDocument() {
            const { title } = this.tracked;
            if (document.title !== title) {
                document.title = title;
            }
        },
        setTitle(newTitle) {
            const hcstatic = window.hcstatic;
            const { association_name: assoc } = hcstatic;
            const product = get(path('product'));
            if (newTitle) {
                const title = `${assoc?.toUpperCase()} - ${product.toUpperCase()} - ${newTitle}`;
                this.tracked.title = title;
                documentTitleUpdate({ title });
            }
        }
    };
    api.setup();
    return api;
});
